import "./Registracion.css";
import MultiTab from "../MultiTab/MultiTab";
import { TabsData } from "./TabsData";
import { logoutRegistro } from "../../../context/Actions/registro/logoutRegistro";
import { hideModal } from "../../../context/Actions/modal/modal";
import { PortalContext } from "../../../context/Provider";
import { useContext } from "react";
import { logoutValidaMobile } from "../../../context/Actions/registro/validaMobile";
import { hideSegundoModal } from "../../../context/Actions/segundoModal/segundoModal";
import { localidadReset } from "../../../context/Actions/localidad/localidad";

const Registracion = ({ dissmiss }) => {
  const {
    registroDispatch,
    segundoModalDispatch,
    validaMobileDispatch,
    localidadDispatch,
  } = useContext(PortalContext);

  const onClickCerrar = () => {
    logoutRegistro()(registroDispatch);
    logoutValidaMobile()(validaMobileDispatch);
    hideSegundoModal()(segundoModalDispatch);
    localidadReset()(localidadDispatch);
  };

  return (
    <div className="contenedorRegistro">
      <div className="headerRegistro">
        <h1 className="rb32b titulo m-0">Creá tu cuenta</h1>
        <h2 className="ptur-pregunta-signup rb18m f-left">
          ¿Ya tenés una cuenta?{" "}
          <a onClick={dissmiss} className="c-latex30 rb18m">
            Iniciá sesión
          </a>
        </h2>
        <a
          className="c-latex30 linkInicioSesion rb18m pointer"
          onClick={onClickCerrar}
        >
          Cerrar
        </a>
      </div>
      <MultiTab tabs={TabsData} dissmiss={dissmiss} />
    </div>
  );
};
export default Registracion;
